import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Wrapper } from 'styles/form.style';
import { Page } from 'components/page';

export const MaintenancePage = () => (
  <Page>
    <Wrapper data-testid="maintenance-page">
      <Text textStyle="heading800" tag="h1" margin={{ bottom: '16px' }}>
        We&rsquo;re down for scheduled maintenance.
      </Text>
      <Text tag="p">
        Our service is temporarily unavailable. Please check back soon.
      </Text>
    </Wrapper>
  </Page>
);
